// utils
import apiSlice from "src/utils/api-slice";
import { setURLParams } from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getTasks: "/web/task_manager/query_by_page"
};

// ----------------------------------------------------------------------

const {
    useGetTaskListQuery
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getTaskList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "TaskList" ],
            query: (request) => `${ API_ENDPOINTS.getTasks }${ setURLParams(request) }`,
            transformResponse: ({ data }) => data
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetTaskListQuery
};
